import { isEmpty, isObject, toUpper } from 'lodash';
import { ARMENIA_ISO3, COUNTRIES, YEREVAN_CITY_VILLAGE } from '../constants';

export const getCitizenship = (applicantCountry, countries) => {
  const country = applicantCountry || COUNTRIES.ARM.nameHY;
  return {
    isArmCitizen: toUpper(country) === COUNTRIES.ARM.nameHY,
    citizenship: countries?.find((c) => c.nameHY === country),
  };
};

export const findIsYerevan = (state) => !isEmpty(state) && isObject(state) && state?.id === 1;

export const findCountriesByISO3 = (iso3Array, countries) => {
  const foundCountries = countries.filter((country) => iso3Array.includes(country.iso3));
  return foundCountries.length > 1 ? foundCountries : foundCountries[0];
};

export const isArmenianCountry = (country) => country && country.iso3 === ARMENIA_ISO3;

export const attachDefaultCityVillage = (data) => {
  if (findIsYerevan(data.state)) {
    // eslint-disable-next-line no-param-reassign
    data.cityVillage = YEREVAN_CITY_VILLAGE;
  }

  return data;
};
